"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
const core_1 = require("@emotion/core");
const styles_1 = require("../../../../lib/styles");
const Col = styled_1.default.div `
  display: flex;
  flex-direction: column;
  ${(props) => props.grow
    ? core_1.css `
          flex-grow: 1;
        `
    : props.size === 0
        ? ``
        : core_1.css `
          flex: ${props.size || 1};
        `};

  ${(props) => props.centerVertical &&
    core_1.css `
      justify-content: center;
    `}

  ${(props) => props.alignVertical &&
    core_1.css `
      justify-content: ${props.alignVertical};
    `}

  ${(props) => props.centerHorizontal &&
    core_1.css `
      align-items: center;
    `}

  ${(props) => props.alignHorizontal &&
    core_1.css `
      align-items: ${props.alignHorizontal};
    `}

  ${(props) => styles_1.getPaddingFromProps(props)};
`;
exports.default = Col;
